import { Skeleton } from '@aspid/ui';
import { Box } from '@mui/material';


import type { FileRendererSkeletonProperties } from './FileRendererSkeleton.types';

export const FileRendererSkeleton = ({
  dataTest = 'file_renderer_skeleton',
}: FileRendererSkeletonProperties) => {
  return (
    <Box
      data-testid={dataTest}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 1.75,
        py: 1.25,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '6px'
      }}>
      <Skeleton width={32} height={32} borderRadius={4} />
      <Box
        sx={{
          flex: 1,
          minWidth: 0
        }}>
        <Skeleton width='45%' height={13} />
        <Skeleton width='25%' height={11} style={{ marginTop: 2 }} />
      </Box>
      <Skeleton width={60} height={20} borderRadius={10} />
    </Box>
  );
};
